import { memo } from "react";
import Button from "@mui/material/Button";
import { WebRoutes } from "consts/enpoints/web";
import { DOMAIN } from "consts/general";
import { isInIframe, when } from "util/support";
import useLogout from "features/auth/useLogout";
import useAuthentication from "features/auth/useAuthentication";
import PreApplicationCard from "./PreApplicationCard";
import ResendVerificationLink from "./ResendVerificationLink";

type Props = {
    readonly email: string;
};

const RegistrationCompleteCta = ({ email }: Props) => {
    const { isAuthenticated } = useAuthentication();
    const logout = useLogout();

    const navigateLogin = () => (
        when(
            isInIframe,
            () => (
                window.parent.postMessage({
                    type: 'CHILD_REDIRECT',
                    payload: {
                        href: `${window.location.origin}${WebRoutes.Login.Index}`
                    },
                }, `https://${DOMAIN}`)
            ),
            () => when(
                isAuthenticated,
                logout,
                () => window.location.href = WebRoutes.Login.Index
            )
        )
    );

    return (
        <PreApplicationCard
            slotProps={{
                header: {
                    title: 'Your account is created',
                    subheader: `We've sent a confirmation link to ${email} to verify your email address.`,
                    subheaderTypographyProps: {
                        sx: {
                            color: 'black'
                        }
                    }
                }
            }}
        >
            <Button
                fullWidth
                variant='contained'
                color='success'
                onClick={navigateLogin}
                sx={{
                    marginBottom: "20px"
                }}
            >
                Go to login page
            </Button>
            <ResendVerificationLink
            
            email={email}
            />
        </PreApplicationCard>
    );
};

export default memo(RegistrationCompleteCta);
